// extracted by mini-css-extract-plugin
export var cartIcon = "_ks-0";
export var cartIconContainer = "_ks-1";